import React from "react"
import PropTypes from "prop-types"
import { useIntl } from "gatsby-plugin-intl"

import H from "components/atoms/H"
import MarkdownRenderer from "components/atoms/MarkdownRenderer"
import { StyledWrapper, StyledSection, paragraphStyles } from "./Legals.styles"

const Legals = ({ topics, pageType }) => {
  const { formatMessage } = useIntl()
  return (
    <StyledWrapper>
      {topics.map((topic) => (
        <StyledSection key={topic}>
          <H as="h3">
            {formatMessage({ id: `pages.${pageType}.${topic}Heading` })}
          </H>
          <MarkdownRenderer
            customStyles={paragraphStyles}
            content={formatMessage({ id: `pages.${pageType}.${topic}Text` })}
            skipHtml
          />
        </StyledSection>
      ))}
    </StyledWrapper>
  )
}

Legals.propTypes = {
  topics: PropTypes.arrayOf(PropTypes.string).isRequired,
  pageType: PropTypes.string.isRequired,
}

export default Legals
